/* eslint-disable react-hooks/exhaustive-deps */
import { RootState } from "@base/store";
import { WithAnalytics } from "@base/utils/hoc/withSendPageAnalytics";
import Button from "@components/atoms/button";
import GameInfo from "@components/molecules/game-Info-card";
import Header from "@components/molecules/header";
import Layout from "@components/molecules/layout";
import { ProfileToggle } from "@components/molecules/profile-toggle";
import Tabs from "@components/molecules/tabs";
import { LoaderSnackbarWrapperActions } from "@components/organisms/LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
import theme from "@config/theme";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ExploreIcon from "@mui/icons-material/Explore";
import { Box, MenuItem, SelectChangeEvent } from "@mui/material";
import Grid from "@mui/material/Grid";
import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { gameDetailsActions } from "../game-details/gameDetails.slice";
import { gameActions } from "../game/game.slice";
import { GameProps, GamesResponse } from "../game/game.type";
import { homeActions } from "./home.slice";
import {
  Content,
  ContentHeader,
  GamesContainer,
  NoGamesTypography,
  NoGamesWrapper,
  Select,
  Title,
  TitleWrapper,
} from "./home.styled";

import { ReactComponent as CreateGameIcon } from "@assets/images/player/Sport, Outdoor _ soccer, football, game, activity, man, running, play.svg";
import { ReactComponent as SettingsGearIcon } from "@assets/images/settings/settings-gear.svg";

type ReduxProps = ConnectedProps<typeof connector>;

declare var _cio: any;

const Home = ({
  setUser,
  setSelectedGame,
  reset,
  pastGames,
  upcomingGames,
  getGamesByRsvp,
  getGameById,
  setCookieConsent,
  waitListGames,
}: ReduxProps) => {
  const navigate = useNavigate();
  const ancc = Cookies.get("ANCC");
  const gameToBeCreated = localStorage.getItem("gameToBeCreated");

  const contentTitleRef = useRef<HTMLDivElement>();
  const selectedGame = useSelector((state: RootState) => state.selectedGame);
  const user = useSelector((state: RootState) => state.user.user);
  const sharedGameId = localStorage.getItem("sharedGameId");

  // const [titleHeight, setTitleHeight] = useState<number>(0);
  const [gameStatus, setGameStatus] = useState<string>("A");

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setGameStatus(event.target.value as string);
  };

  const handleGameSelection = async (gameID: string) => {
    const res = await getGameById({ id: gameID, isAuth: true });
    if (res?.meta?.requestStatus === "fulfilled") {
      setSelectedGame(res?.payload);
    }
  };

  const displayCookieConsent = () => {
    switch (ancc) {
      case undefined:
        if (window.location.pathname === "/") {
          setCookieConsent({ cookieConsent: false });
        } else {
          setCookieConsent({ cookieConsent: true });
        }
        break;
      case "true":
        setCookieConsent({ cookieConsent: false });
        break;
      case "false":
        setCookieConsent({ cookieConsent: false });
        break;
      default:
        break;
    }
  };

  const UpcomingGameList = () => {
    const [gameInfo, setGameInfo] = useState<GameProps[]>([]);

    const filterGames = (gamesArray: GamesResponse[]) => {
      const games: GameProps[] = [];
      gamesArray.forEach((game: GamesResponse) => {
        games.push(game.game);
      });
      setGameInfo(games);
    };

    const getGamesInfo = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();
      const res = await upcomingGames({
        date: formattedDate,
        rsvp: gameStatus,
      });
      if (res?.meta?.requestStatus === "fulfilled") {
        filterGames(res?.payload);
      }
    };

    useEffect(() => {
      if (user.token && !selectedGame.id) {
        getGamesInfo();
      }
    }, []);

    return (
      <GamesContainer>
        {gameInfo && gameInfo?.length > 0 ? (
          gameInfo?.map((game, index) => (
            <Box key={index}>
              <GameInfo
                key={index}
                rsvp="A"
                teamA={game?.sides[0]?.side_name}
                teamB={game?.sides[1]?.side_name}
                scoreA={undefined}
                scoreB={undefined}
                startDate={game?.start_date}
                location={game?.address?.properties?.name || game?.location}
                title={game?.title}
                onClick={() => handleGameSelection(game?.id)}
              />
            </Box>
          ))
        ) : (
          <NoGamesWrapper>
            <NoGamesTypography>{"Find or create a game."}</NoGamesTypography>
            <CreateGameIcon />
          </NoGamesWrapper>
        )}
      </GamesContainer>
    );
  };

  const PastGameList = () => {
    const [pastGameInfo, setPastGameInfo] = useState<GameProps[]>([]);
    const filterGames = (gamesArray: GamesResponse[]) => {
      const games: GameProps[] = [];
      gamesArray.forEach((game: GamesResponse) => {
        games.push(game.game);
      });
      setPastGameInfo(games);
    };
    const getPastGamesInfo = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();
      const res = await pastGames({ date: formattedDate, rsvp: gameStatus });
      if (res?.meta?.requestStatus === "fulfilled") {
        filterGames(res?.payload);
      }
    };

    useEffect(() => {
      if (user.token && !selectedGame.id) {
        getPastGamesInfo();
      }
    }, []);

    return (
      <GamesContainer>
        {pastGameInfo && pastGameInfo?.length > 0 ? (
          pastGameInfo?.map((game, index) => (
            <Box key={index}>
              <GameInfo
                key={index}
                rsvp="A"
                teamA={game?.sides[0]?.side_name}
                teamB={game?.sides[1]?.side_name}
                scoreA={game?.sides[0]?.score?.score_value}
                scoreB={game?.sides[1]?.score?.score_value}
                startDate={game?.start_date}
                location={game?.address?.properties?.name || game?.location}
                title={game?.title}
                onClick={() => handleGameSelection(game?.id)}
              />
            </Box>
          ))
        ) : (
          <NoGamesWrapper>
            <NoGamesTypography>{"Find or create a game."}</NoGamesTypography>
            <CreateGameIcon />
          </NoGamesWrapper>
        )}
      </GamesContainer>
    );
  };

  const SubGameList = () => {
    const [pastGameInfo, setPastGameInfo] = useState<GameProps[]>([]);
    const filterGames = (gamesArray: GamesResponse[]) => {
      const games: GameProps[] = [];
      gamesArray.forEach((game: GamesResponse) => {
        games.push(game?.game);
      });
      setPastGameInfo(games);
    };
    const getGamesInfo = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();
      const res = await waitListGames(formattedDate);
      if (res?.meta?.requestStatus === "fulfilled") {
        filterGames(res?.payload);
      }
    };

    useEffect(() => {
      if (user.token && !selectedGame.id) {
        getGamesInfo();
      }
    }, []);

    return (
      <GamesContainer>
        {pastGameInfo && pastGameInfo?.length > 0 ? (
          pastGameInfo?.map((game, index) => (
            <Box key={index}>
              <GameInfo
                key={index}
                rsvp="N"
                teamA={game?.sides[0]?.side_name}
                teamB={game?.sides[1]?.side_name}
                scoreA={game?.sides[0]?.score?.score_value}
                scoreB={game?.sides[1]?.score?.score_value}
                startDate={game?.end_date}
                location={game?.address?.properties?.name || game?.location}
                title={game?.title}
                onClick={() => handleGameSelection(game?.id)}
              />
            </Box>
          ))
        ) : (
          <NoGamesWrapper>
            <NoGamesTypography>{"Find or create a game."}</NoGamesTypography>
            <CreateGameIcon />
          </NoGamesWrapper>
        )}
      </GamesContainer>
    );
  };

  const NotAttendingGameList = () => {
    const [pastGameInfo, setPastGameInfo] = useState<GameProps[]>([]);
    const filterGames = (gamesArray: GamesResponse[]) => {
      const games: GameProps[] = [];
      gamesArray.forEach((game: GamesResponse) => {
        games.push(game?.game);
      });
      setPastGameInfo(games);
    };
    const getPastGamesInfo = async () => {
      const res = await getGamesByRsvp("N");
      if (res?.meta?.requestStatus === "fulfilled") {
        filterGames(res?.payload);
      }
    };

    useEffect(() => {
      if (user.token && !selectedGame.id) {
        getPastGamesInfo();
      }
    }, []);

    return (
      <GamesContainer>
        {pastGameInfo && pastGameInfo?.length > 0 ? (
          pastGameInfo?.map((game, index) => (
            <Box key={index}>
              <GameInfo
                key={index}
                rsvp="N"
                teamA={game?.sides[0]?.side_name}
                teamB={game?.sides[1]?.side_name}
                scoreA={game?.sides[0]?.score?.score_value}
                scoreB={game?.sides[1]?.score?.score_value}
                startDate={game?.end_date}
                location={game?.address?.properties?.name || game?.location}
                title={game?.title}
                onClick={() => handleGameSelection(game?.id)}
              />
            </Box>
          ))
        ) : (
          <NoGamesWrapper>
            <NoGamesTypography>{"Find or create a game."}</NoGamesTypography>
            <CreateGameIcon />
          </NoGamesWrapper>
        )}
      </GamesContainer>
    );
  };

  const handleSettingsClick = () => {
    navigate("/settings");
  };

  const TabPanels = [
    {
      id: 0,
      children: <UpcomingGameList />,
    },
    {
      id: 1,
      children: <PastGameList />,
    },
  ];

  const homeRender = () => (
    <Layout
      isLayout
      HeaderChildren={
        <Header
          title="Home"
          icon={<SettingsGearIcon />}
          handleClick={handleSettingsClick}
        />
      }
    >
      <ProfileToggle />
      <Content>
        <ContentHeader ref={contentTitleRef}>
          <TitleWrapper>
            <Title>Games</Title>
            <Select
              sx={{
                width: "81px",
                fontFamily: "NotoSans-Regular",
                fontSize: "14px",
              }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={gameStatus}
              onChange={(e: SelectChangeEvent<unknown>) => {
                handleChange(e);
              }}
            >
              <MenuItem sx={{ minHeight: "0px !important" }} value={"A"}>
                In
              </MenuItem>
              <MenuItem sx={{ minHeight: "0px !important" }} value={"N"}>
                Out
              </MenuItem>
              <MenuItem sx={{ minHeight: "0px !important" }} value={"w"}>
                Sub
              </MenuItem>
            </Select>
          </TitleWrapper>
          {gameStatus === "A" ? (
            <Tabs tabs={["Upcoming", "PAST"]} TabPanels={TabPanels} />
          ) : gameStatus === "N" ? (
            <NotAttendingGameList />
          ) : (
            <SubGameList />
          )}
        </ContentHeader>

        <Box mb={3} mt={1}>
          <Grid container spacing={2} justifyContent="center" columns={2}>
            <Grid item style={{ width: "48%" }}>
              <Button
                iscta
                textColor={theme.palette.grey[100]}
                text="Find a game"
                type="button"
                color="primary"
                onClick={() => {
                  navigate("/marketplace");
                }}
                startIcon={<ExploreIcon />}
              />
            </Grid>
            <Grid item style={{ width: "48%" }}>
              <Button
                iscta
                textColor={theme.palette.grey[100]}
                text="Create a game"
                type="button"
                color="primary"
                onClick={() => {
                  navigate("/game", {
                    state: { from: "/home" },
                  });
                }}
                startIcon={<AddBoxIcon />}
              />
            </Grid>
          </Grid>
        </Box>
      </Content>
    </Layout>
  );

  useEffect(() => {
    if (user.uuid && sharedGameId) {
      handleGameSelection(sharedGameId);
    }
    // Segment handles this on the backend
    // if (user.uuid) {
    //   _cio.identify({
    //     // Required attributes — you must include your customer's identifier (this can be either an email address or a unique ID value) in a property named "id". See below for more details.
    //     id: user?.uuid,

    //     // Strongly recommended when you first identify someone
    //     created_at: Date.now(), // Timestamp in representing when the user
    //     // first signed up in Unix format.

    //     // Other attributes (properties you'll reference with liquid)
    //     email: user?.email,
    //     first_name: user?.firstName,
    //     last_name: user?.lastName,
    //   });
    // }
    displayCookieConsent();
    return () => {
      if (user.uuid && sharedGameId) {
        localStorage.removeItem("sharedGameId");
      }
    };
  }, [user]);

  useEffect(() => {
    if (selectedGame.id) {
      navigate("/game-details", {
        state: { from: "/home" },
      });
    }
  }, [selectedGame]);

  useEffect(() => {
    reset();
    // Make sure _cio is available
    if (_cio) {
      _cio.on("in-app:message-opened");
    }
    if (gameToBeCreated) {
      navigate("/game", {
        state: { from: "/home" },
      });
    }

    // Cleanup
    return () => {
      _cio.off("in-app:message-opened");
    };
  }, []);

  return <>{homeRender()}</>;
};

const mapDispatchToProps = {
  setCookieConsent: LoaderSnackbarWrapperActions.setGlobalAppearances,
  setUser: homeActions.setUser,
  getGamesByRsvp: gameActions.getGames,
  upcomingGames: gameActions.upcomingGames,
  pastGames: gameActions.pastGames,
  getGameById: gameDetailsActions.getGameById,
  reset: gameDetailsActions.reset,
  setSelectedGame: gameDetailsActions.setSelectedGame,
  resetSelectedGame: gameDetailsActions.reset,
  waitListGames: gameActions.waitListGames,
};

const connector = connect(undefined, mapDispatchToProps);
const HomeRedux = connector(WithAnalytics(Home));

export { HomeRedux as Home };
